
import { initlogin} from "./initlogin.js";
let _InitialData= window._InitialData
try{
window["_PRODUCTINFO"] = GetProduct();

initlogin();
}
catch(e){
console.error("Login Index Load Error:"+e);
}

function GetProduct() {
    
    let ProdInfo = {
        TagLine: "",
        Title: "",
        Logo: '',
        SupportEMail: "",
        SupportWhatsAppNo: "",
        SupportWhatsAppText: "",
        FeatureURL: "",
        TOUURL: "",
        Version: "",
        Mode: 0
    };
    ProdInfo = (_InitialData.ProdInfo || ProdInfo);
    if (ProdInfo.SupportWhatsAppText === null) {
        ProdInfo.SupportWhatsAppText = 'Hi!'
    }
    if (ProdInfo.SupportWhatsAppNo === null) {
        ProdInfo.SupportWhatsAppNo = ''
    }
    
    
    
    ProdInfo["Logo"] = "Images/logo.png";
    switch (ProdInfo.Mode) {
        case 2:
            ProdInfo.Title = "LiveImpex";
            ProdInfo.TagLine = "India’s #1 Customs Compliance Platform";
            ProdInfo["Logo"] = "Images/LiveImpex_Logo.png";
            ProdInfo.FeatureURL = "https://www.softlinkglobal.com/products/live-impex";
            if ((ProdInfo.SupportEMail || "").length == 0)
                ProdInfo.SupportEMail = "support@softlinkglobal.com";
            return ProdInfo;
        case 1:
            ProdInfo.Title = "LiveIMPEXPro";
            ProdInfo.TagLine = "Live IMPEX Pro - India’s #1 Customs Compliance + Accounting Platform";
            ProdInfo.FeatureURL = "https://www.softlinkglobal.com/products/logi-sys-pro";
            ProdInfo["Logo"] = "Images/Logi-Sys-small-pro.png";
            if ((ProdInfo.SupportEMail || "").length == 0)
                ProdInfo.SupportEMail = "support@softlinkglobal.com";
            return ProdInfo;
    }
    ProdInfo.Title = "Logi-Sys";
    ProdInfo.FeatureURL = "https://www.softlinkglobal.com/products/logi-sys";
    if ((ProdInfo.SupportEMail || "").length == 0)
        ProdInfo.SupportEMail = "logisys.support@softlinkglobal.com";
    document.title = ProdInfo.Title;
    return ProdInfo;
}
